<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<h2>{{ autor?.nombre }}</h2>
<div class="autores">
  <mat-card class="autor">
    <!-- <mat-card-title>{{ 'Leti' }}</mat-card-title> -->
    <!-- <mat-card-subtitle>{{ autor.nombre }}</mat-card-subtitle> -->
    <mat-card-content [innerHTML]="autor?.bio"></mat-card-content>
  </mat-card>
  <div class="link">
    <a [routerLink]="'/autorxs'">Volver</a>
  </div>
</div>